import { render, staticRenderFns } from "./TableQuery.vue?vue&type=template&id=67ac0150&scoped=true"
import script from "./TableQuery.vue?vue&type=script&lang=js"
export * from "./TableQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac0150",
  null
  
)

export default component.exports